import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function Hero() {
  return <header className="border-b-4 border-gold bg-navy px-3 pb-4 pt-3 text-center sm:px-6 sm:pb-5 sm:pt-4" data-id="element-82" data-mp="eiv62y7sfcld">
      <h1 className="text-[0.95rem] font-extrabold uppercase leading-[1.12] text-white sm:text-[1.45rem]" data-id="element-83" data-mp="9llat1xpw6pm">
        THE COMPLETE FAULT-FINDING SYSTEM FOR{' '}
        <span className="text-gold" data-id="element-84" data-mp="1297a3xzwwp6o">COMMERCIAL KITCHEN EQUIPMENT TECHNICIANS</span>
      </h1>
      <p className="mt-1.5 font-heading text-[1.35rem] font-black uppercase leading-[1.04] text-white sm:text-[2.3rem]" data-id="element-85" data-mp="xae5yw6imaj6">
        STOP GUESSING. <span className="text-gold" data-id="element-86" data-mp="sa9szg4tfxxp">START DIAGNOSING THE FAULT.</span>
      </p>
      <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-[1.35] text-white/85 sm:text-[0.95rem]" data-id="element-87" data-mp="ncq1vfn0rqoc">
        Identify symptoms, check possible causes, test key components, and follow structured
        fault-finding paths across commercial kitchen equipment—all in one professional diagnostic
        system.
      </p>

      <BoxImage className="mx-auto mt-2 max-w-[270px] sm:max-w-[360px]" data-id="element-88" data-mp="3j9u252lgjune" />

      <div className="mx-auto mt-2 max-w-md" data-id="element-89" data-mp="3o858328mtl0c">
        <CTAButton label="🚀 YES! I WANT MY DIAGNOSTIC SYSTEM NOW" data-id="element-90" data-mp="3o6u697yqynbv" />
        <p className="mt-2 text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-91" data-mp="399bc1q3avhx1">
          🛡️ 7-Day Money-Back Guarantee — Zero Risk
        </p>
      </div>
    </header>;
}